var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgExcelIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.366 10.538 5.448 9.32v9.006a.745.745 0 0 0 .745.744h11.938a.744.744 0 0 0 .747-.744v-3.318l-6.512-4.469Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.366 2.82H6.194a.745.745 0 0 0-.746.744v3.318l6.918 4.062 3.663 1.22 2.849-1.22V6.882l-6.512-4.063Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.448 6.882h6.918v4.062H5.448V6.882Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.4 6.07H5.447v10.156h4.951a.75.75 0 0 0 .746-.745V6.814a.75.75 0 0 0-.746-.745Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.992 6.476H5.448v10.156h4.544a.75.75 0 0 0 .746-.745V7.22a.75.75 0 0 0-.746-.744Z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.992 6.476H5.448v9.343h4.544a.75.75 0 0 0 .746-.744V7.22a.75.75 0 0 0-.746-.744Z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.585 6.476H5.448v9.343h4.137a.75.75 0 0 0 .747-.744V7.22a.75.75 0 0 0-.747-.744Z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.124 6.476h7.461a.746.746 0 0 1 .747.744v7.449a.746.746 0 0 1-.747.744h-7.46a.745.745 0 0 1-.747-.744V7.22a.745.745 0 0 1 .746-.744Z",
    fill: "url(#Excel_Icon_svg__a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m3.69 13.365 1.57-2.428-1.438-2.413h1.155l.784 1.545c.072.147.125.255.149.328h.01c.052-.118.106-.23.163-.341l.839-1.53h1.062l-1.474 2.4 1.512 2.44H6.89l-.906-1.694a1.476 1.476 0 0 1-.107-.228h-.015c-.027.077-.062.15-.105.22l-.933 1.701H3.69Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.131 2.82h-5.765v4.062h6.512V3.564a.746.746 0 0 0-.747-.745Z",
    fill: "#33C481"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.366 10.944h6.512v4.063h-6.512v-4.063Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Excel_Icon_svg__a",
    x1: 2.937,
    y1: 5.891,
    x2: 8.773,
    y2: 15.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
};
export { SvgExcelIcon as ReactComponent };
export default __webpack_public_path__ + "7e33013c8c9dc0a0b5061d6dbbde3f3d.svg";